import {queryOptions} from '@tanstack/react-query';
import {parse, looseObject, number} from 'valibot';

import {
  getSmartseerProfile,
  type GetSmartseerProfileParams,
} from '@/api/bffSupport';

const SmartseerProfileSchema = looseObject({
  intent: looseObject({
    sessionChurnRisk: number(),
  }),
});

export const smartseerProfile = (params: GetSmartseerProfileParams) => {
  return queryOptions({
    queryKey: ['bff-support', 'smartseer-profile', params],
    queryFn: async ({signal}) => {
      const response = await getSmartseerProfile(params, {signal});
      if (response.status !== 200) {
        throw new Error('Failed to fetch smartseer profile');
      }
      // BFF just proxies the raw response from smartseer directly,
      // so we need to do some basic validation here.
      const rawProfile = JSON.parse(response.data.rawProfile ?? '');
      return parse(SmartseerProfileSchema, rawProfile);
    },
  });
};
